import axios from 'axios'

import type { TCity } from '../types/client-form-promise-city.type'

export type TCustomerFormLoadCityService = {
  payload: {
    ufId: string
  }
}

export const customerFormLoadCityService = async ({
  payload,
}: TCustomerFormLoadCityService): Promise<TCity[]> => {
  const response = await axios.get(
    `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${payload.ufId}/municipios`,
  )

  return response.data
}
